module.exports = __webpack_public_path__ + "img/753-066618.png";